import { Component, inject, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { LocationService } from './location-required.service';
import { Router, RouterModule } from '@angular/router';
import { NgIf } from '@angular/common';

@Component({
  standalone: true,
  imports: [
    NgIf,
    RouterModule
  ],
  selector: 'app-location-required',
  styles: `
    :host{
        display: grid;
        width: 100vw;
        height: 100vh;
        place-content: center;
        img{
            width:500px;
          }
      }
    `,
  template: `
    <div class="flex flex-col items-center justify-center h-screen text-center">
      @if(!_LocationService.denied())
        {
          <h2 class="text-2xl font-bold mb-4">Location Required</h2>
      <img src="https://cdn-icons-png.flaticon.com/256/3183/3183012.png"  alt="chair" fetchpriority="high" style="max-width: 833px;">
      <p class="mb-6">
        We need your location to load the app.  
        Please enable location services in your browser settings.
      </p>
      <button 
        class="btn btn-primary px-4 py-2 bg-blue-600 text-white rounded"
        (click)="reloadPage()">
        Retry
      </button>
        }@else {
           <div *ngIf="_LocationService.loading()">Loading location...</div>
    <div *ngIf="_LocationService.denied()">❌ Location access denied by user.</div>
        }
    </div>
  `
})
export class LocationRequiredComponent implements OnInit, OnChanges {

  _LocationService: LocationService = inject(LocationService);
  _Router: Router = inject(Router);

  ngOnInit(): void {
    if (this._LocationService.coords()) {
      this._Router.navigate(['/dashboard']);
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log(changes);
  }

  reloadPage() {
    this._LocationService.requestLocation().then(() => {
      this._Router.navigate(['/dashboard']);
    })
  }
}
